// English strings for the external AI provider (aiprov stream; owner decision B-13, PD-600 – PD-606):
// the write-only provider key, the connection test, provider outcomes and the personal-data rule.
// Arabic: ar-aiprov.ts. Wording keeps AI advisory and never displays a key.
export const enAiprov = {
  // ------------------------------------------------------------ validation and API messages
  'ai.v.personal_data_not_allowed': 'Personal data can never be sent to an external AI provider. Switch personal data off to use this provider.',
  'ai.v.credential_required': 'Store an API key for this provider (or have the operator configure an installation key) before switching AI on.',
  'ai.api.credentialUnsupported': 'This provider does not use an API key.',
  'ai.api.keyRingMissing': 'Provider keys cannot be stored because no encryption key ring is configured.',
  'ai.api.testUnavailable': 'This provider cannot be tested.',

  // ------------------------------------------------------------ outcomes (run and test)
  'ai.ui.reason.credential_rejected': 'The AI provider rejected the API key. Nothing is shown.',
  'ai.ui.reason.rate_limited': 'The AI provider is busy (rate limited). Nothing is shown; try again later.',
  'ai.ui.reason.personal_data_not_allowed': 'Personal data cannot be sent to an external provider, so the request was not sent.',
  'ai.ui.reason.ok': 'Answered',

  // ------------------------------------------------------------ provider key (write-only)
  'ai.ui.cred.title': 'Provider API key',
  'ai.ui.cred.intro': 'Write-only. A stored key is sealed and is never shown again, not even to administrators.',
  'ai.ui.cred.label': 'New API key',
  'ai.ui.cred.hint': 'Paste the key from the provider account. It replaces any key stored for this organisation.',
  'ai.ui.cred.save': 'Store key',
  'ai.ui.cred.remove': 'Remove stored key',
  'ai.ui.cred.statusOrganisation': 'Organisation key stored (version {version}, {time}).',
  'ai.ui.cred.statusInstallation': 'No organisation key: the installation key configured by the operator is used.',
  'ai.ui.cred.statusNone': 'No key stored. AI with this provider cannot be switched on yet.',
  'ai.ui.cred.stored': 'Key stored.',
  'ai.ui.cred.removed': 'Stored key removed.',

  // ------------------------------------------------------------ connection test
  'ai.ui.test.button': 'Test connection',
  'ai.ui.test.intro': 'Sends a synthetic prompt that contains no Passage data, to check the key and the model.',
  'ai.ui.test.ok': 'Connection works: {model} answered in {ms} ms ({input} input and {output} output tokens).',
  'ai.ui.test.failed': 'Connection test failed: {reason}',
  'ai.ui.test.last': 'Last test {time}: {outcome}',

  // ------------------------------------------------------------ personal data and activity
  'ai.ui.personalExternal': 'Personal data is never sent to an external provider: only aggregates and fact codes leave Passage (owner decision, 17 October 2026).',
  'ai.ui.act.usage': 'Tokens',
  'ai.ui.act.usageValue': '{input} in / {output} out · {ms} ms',
} as const;
